module.exports = __webpack_public_path__ + "static/heater-9f7ccdfd5bb15fab9439fdd8287a8414.jpg";